import $ from 'jquery';

export default () => {
  const errorLoading = Drupal.t('The results could not be loaded.');
  const loadingMore = Drupal.t('Loading more results');
  const noResults = Drupal.t('No results found');
  const searching = Drupal.t('Searching');
  const maximumSelected = Drupal.t('You can only select %maximum item');
  const inputTooLong = Drupal.t('Please delete %number character');
  const inputTooShort = Drupal.t('Please enter %number or more characters');
  const selector = '#block-news-page-filters, #views-exposed-form-adria-balkan-newsfeed-page';
  const placeholder = Drupal.t('Category');

  Drupal.behaviors.news_filter_select = {
    attach: (context, settings) => {
      $(selector, context).addBack(selector).first().find('select').once('select2').select2({
        // To hide search box
        minimumResultsForSearch: Infinity,
        width: '100%',
        placeholder,
        language: {
          errorLoading: () => errorLoading,
          loadingMore: () => loadingMore,
          noResults: () => noResults,
          searching: () => searching,
          maximumSelected: ({ maximum }) => maximumSelected.replace('%maximum', maximum),
          inputTooLong: ({ maximum, input: { length } }) => inputTooLong.replace('%number', length - maximum),
          inputTooShort: ({ minimum, input: { length } }) => inputTooShort.replace('%number', minimum - length),
        }
      });
    }
  };
}
